export class BulletChartOptions {
    isContextVisible = true;
    isTendencyVisible = true;
    isQualityVisible = true;
    isRangeVisible = true;
    isTargetVisible = true;
    decimals = 2;
    valueFormat: (d) => string;
}